import { createApiClient } from "Network/ApiClient";

export const providerAxiosInstance = createApiClient("Provider/");
